<template>
    <div>
        <div class="web-footer-left">
            <p>地址：山西省临汾市尧都区洪家楼北街33号</p>
            <p>邮编：041000 传真：0357-2116792</p>
            <p>电话：0357-2116792</p>
        </div>
        <div class="web-footer-right">
            <img :src="this.$api_url+'/static/images/conac.png'">
            <p>山西省临汾工商行政管理学校 版权所有 © 2020-2021</p>
            <p>晋ICP备07002696—1</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "page_footer",
    data() {
        return {};
    },
    // 监听属性
    computed: {},
    // 监控data数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建之前
    beforeCreate() {
    },
    // 生命周期 - 创建完成
    created() {
    },
    // 生命周期 - 挂载之前
    beforeMount() {
    },
    // 生命周期 - 挂载完成
    mounted() {
    },
    // 生命周期 - 更新之前
    beforeUpdate() {
    },
    // 生命周期 - 更新之后
    updated() {
    },
}
</script>